import React from 'react';
// @ts-ignore
import styles from './Buttons.module.scss';
import LinkButton from './LinkButton';
import { Theme } from '../../Enums/Theme.enum';
import Text from '../Base/Text/Text';

interface AttachmentButtonProps {
	onClick: () => void;
	onRemove?: () => void;
	title?: string;
	additionalText?: string;
}

export default function AttachmentButton(props: AttachmentButtonProps) {
	const { onClick, onRemove, title = 'Příloha', additionalText } = props;

	const handlePress = () => {
		onClick?.();
	};

	const handleRemove = () => {
		onRemove?.();
	};

	return (
		<div className={styles.attachmentButton} onClick={handlePress}>
			<img
				className={styles.icon}
				src={'/dist/icons/v2/attachment-blue.svg'}
				alt={'attachment icon'}
			/>
			<LinkButton title={title} theme={Theme.BLUE} />
			{additionalText && (
				<Text tx={` - ${additionalText}`} className={styles.additionalText} />
			)}
			{onRemove && (
				<img
					className={styles.remove}
					src={'/dist/icons/xmark-solid-red.svg'}
					onClick={handleRemove}
				/>
			)}
		</div>
	);
}
